import React, { useCallback, useMemo } from 'react';
import { useController } from 'react-hook-form';
import CustomSelectField from 'components/shared/CustomSelectField';
import './SelectField.css';

function SelectField({ name, options, valueKey, ...rest }) {
  const {
    field: { value, onChange }
  } = useController({ name });
  const byValue = useMemo(
    () =>
      options.reduce((acc, option) => {
        acc[option[valueKey]] = option;

        return acc;
      }, {}),
    [options, valueKey]
  );
  const handleChange = useCallback(
    (option) => {
      onChange(option ? option[valueKey] : null);
    },
    [onChange, valueKey]
  );

  return (
    <div className="Select_Wrapper" data-testid='Select_Wrapper'>
      <CustomSelectField name={name} value={byValue[value]} options={options} onChange={handleChange} {...rest} />
    </div>
  );
}

export default SelectField;
